<template>
    <span class="report-line-text" 
        :class="{ 'report-line-text--interactive': !isReadOnly }"
        v-html="text">
    </span>
</template>

<script>
import { evtBus } from '@/main';

export default {
    name: 'reportLineText',
    props: {
        text: {
            type: String,
            required: true
        },
        isReadOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            /**
             * @type {NodeListOf<HTMLSpanElement>}
             */
            annotationItemElements: []
        };
    },

    watch: {
        text(newVal) {
            this.clearAnnotationEventListeners();
            this.configureAnnotationEventListeners();
        }
    },

    methods: {
        setSelectedAnnotationItem(annotationId, force = false) {
            this.annotationItemElements.forEach(element => {
                if (element.getAttribute('data-annotation-id') == annotationId) {
                    const isSelected = element.getAttribute('data-selected') == 'true';
                    if (isSelected && !force) {
                        element.removeAttribute('data-selected');
                        return;
                    }
                    element.setAttribute('data-selected', 'true');
                } else {
                    element.removeAttribute('data-selected');
                }
            });

            this.refreshActiveAnnotationAttribute();
        },

        refreshActiveAnnotationAttribute() {
            let hasActiveAnnotation = this.annotationItemElements.values().toArray().some(element => element.getAttribute('data-selected') == 'true' || element.getAttribute('data-hovered') == 'true');
            if (hasActiveAnnotation)
                this.$el.setAttribute('data-has-active-annotation', 'true');
            else
                this.$el.removeAttribute('data-has-active-annotation');
        },

        setHoveredAnnotationItem(annotationId, emitEvent = false) {
            this.annotationItemElements.forEach(element => {
                if (element.getAttribute('data-annotation-id') == annotationId) {
                    element.setAttribute('data-hovered', 'true');
                } else {
                    element.removeAttribute('data-hovered');
                }
            });
            this.refreshActiveAnnotationAttribute();
            if (emitEvent)
                evtBus.$emit('evt_annotationItem_onFocus', { annotationId : annotationId || null });
        },

        onClickAnnotationItem(event) {
            event.preventDefault();
            event.stopPropagation();
            if (this.isReadOnly)
                return;
            const annotationElement = event.target?.parentElement;
            const annotationId = annotationElement.getAttribute('data-annotation-id');
            if (!annotationId || !annotationId.startsWith('tool_'))
                return;
            console.log('clicking annotation', annotationId);
            this.setSelectedAnnotationItem(annotationId);
            evtBus.$emit('evt_annotationItem_select', { annotationId });
        },

        onMouseEnterAnnotationItem(event) {
            const annotationElement = event.target;
            const annotationId = annotationElement.getAttribute('data-annotation-id');
            // console.log('hovering annotation', annotationId);
            this.setHoveredAnnotationItem(annotationId, true);
            evtBus.$emit('evt_annotationItem_focus', { annotationId });
        },

        onMouseLeaveAnnotationItem(event) {
            const annotationElement = event.target;
            const annotationId = annotationElement.getAttribute('data-annotation-id');
            // console.log('leaving annotation', annotationId);
            this.setHoveredAnnotationItem(null, true);
            evtBus.$emit('evt_annotationItem_blur', { annotationId });
        },

        configureAnnotationEventListeners() {
            // console.log('configureAnnotationEventListeners');
            this.$nextTick(() => {
                this.annotationItemElements = this.$el.querySelectorAll('span[data-type="report-label-annotation-item"]');
                this.annotationItemElements.forEach(element => {
                    element.addEventListener('click', this.onClickAnnotationItem);
                    element.addEventListener('mouseenter', this.onMouseEnterAnnotationItem);
                    element.addEventListener('mouseleave', this.onMouseLeaveAnnotationItem);
                });
            });

            evtBus.$on('evt_annotationItem_onSelect', (payload) => {
                this.setSelectedAnnotationItem(payload.annotationId, true);
            });

            evtBus.$on('evt_annotationItem_onFocus', (payload) => {
                this.setHoveredAnnotationItem(payload.annotationId);
            });
        },

        clearAnnotationEventListeners() {
            // console.log('clearAnnotationEventListeners');
            this.annotationItemElements.forEach(element => {
                element.removeEventListener('mouseenter', this.onMouseEnterAnnotationItem);
                element.removeEventListener('mouseleave', this.onMouseLeaveAnnotationItem);
                element.removeEventListener('click', this.onClickAnnotationItem);
            });
        }
    },

    mounted() {
        // console.log('reportLineText mounted', this.text);
        this.configureAnnotationEventListeners();
    },

    beforeDestroy() {
        this.clearAnnotationEventListeners();
    }
}
</script>

<style scoped>
@import '../../styles/shared/text/report_line_text.css';
@import '../../styles/label_annotations.css';

.report-line-text > :deep(p) {
    margin: 0;
    padding: 0;
}
</style>